import { MainPageAccessor, TransitionsUtilBehavior, TransitionOptions } from "@mcleod/components";

export class AppTransitionsUtilBehavior extends TransitionsUtilBehavior {
    protected constructor() {
        super();
    }

    // When sliding in from the left or right, set top so that slideout
    // displays over the page header by default, unless explicitly defined otherwise.
    public getVerticalSlideoutTopOffset(options: TransitionOptions): number {
        return options?.coverPageHeader !== false ? 0 : MainPageAccessor.pageHeaderHeight;
    }
}

AppTransitionsUtilBehavior.register();
